import React from 'react';
import IconGitHub from './icons/github';
import IconLinkedin from './icons/linkedin';
import IconTwitter from './icons/twitter';
import IconExternal from './icons/external';

const icons = [
  {
    name: 'github',
    link: '',
    icon: <IconGitHub />,
  },
  {
    name: 'linkedin',
    link: '',
    icon: <IconLinkedin />,
  },
  {
    name: 'twitter',
    link: '',
    icon: <IconTwitter />,
  },
  {
    name: 'external',
    link: '',
    icon: <IconExternal />,
  },
];

function Icon({ name }) {
  return icons.find((icon) => icon.name === name).icon;
}

export default Icon;
